/* Chrome Wear buy box: character and size per onesie, bundle tiers, opt-in extras, add to cart. */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var cfg = JSON.parse(root.querySelector('[data-cw-config]').textContent);
    var nf;
    try { nf = new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency }); }
    catch (e) { nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
    var money = function (c) { return nf.format(c / 100); };
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

    var params = new URLSearchParams(location.search);
    var startChar = cfg.chars.indexOf(params.get('character')) > -1 ? params.get('character') : cfg.chars[0];
    var startVariant = params.get('variant');
    var startSize = cfg.defaultSize;
    if (startVariant) {
      Object.keys(cfg.variants).forEach(function (k) {
        if (String(cfg.variants[k].id) === startVariant) { var p = k.split('|'); startChar = p[0]; startSize = p[1]; }
      });
    }

    function nextChar(used) { return cfg.chars.filter(function (c) { return used.indexOf(c) < 0; })[0] || cfg.chars[0]; }
    var rows = [{ char: startChar, size: startSize }];
    rows.push({ char: nextChar([startChar]), size: cfg.defaultSize });
    rows.push({ char: nextChar([startChar, rows[1].char]), size: cfg.defaultSize });

    var state = { n: 1, rows: rows, extras: {} };
    cfg.plushies.concat(cfg.addons).forEach(function (x) { state.extras[x.id] = { on: false, qty: 1 }; });

    var unit = cfg.variants[startChar + '|' + startSize].price;
    var pct = function (n) { return n >= 3 ? cfg.t3 : n === 2 ? cfg.t2 : 0; };
    var off = function (cents, n) { return Math.round(cents * pct(n) / 100); };

    function renderTiers() {
      $('[data-tiers]').innerHTML = [1, 2, 3].map(function (n) {
        var gross = unit * n, save = off(gross, n), tag = '';
        if (n > 1) tag = '<span class="cw-tier__tag' + (n === 3 ? ' cw-tier__tag--pink' : '') + '">SAVE ' + money(save) + '</span>';
        return '<button type="button" role="radio" class="cw-tier cw-cut-sm" data-n="' + n + '" aria-checked="' + (state.n === n) + '">' +
          '<span class="cw-tier__dot"></span><span class="cw-tier__name">' + n + (n === 1 ? ' Onesie' : ' Onesies') + tag + '</span>' +
          '<span class="cw-tier__price">' + money(gross - save) + (n > 1 ? '<span class="cw-tier__was">' + money(gross) + '</span>' : '') + '</span></button>';
      }).join('');
    }

    function renderRows() {
      var html = '';
      for (var i = 0; i < state.n; i++) {
        var r = state.rows[i];
        html += '<div class="cw-row cw-cut-sm" data-row="' + i + '">' +
          '<div class="cw-row__label"><span>' + (state.n > 1 ? 'Onesie ' + (i + 1) : 'Pick your character') + '</span><span class="cw-row__picked">' + r.char + ' / ' + r.size + '</span></div>' +
          '<div class="cw-chars" role="radiogroup" aria-label="Character">' + cfg.chars.map(function (c) {
            return '<button type="button" role="radio" class="cw-char" data-char="' + c + '" aria-checked="' + (c === r.char) + '"><img src="' + cfg.images[c] + '" alt="" width="80" height="80" loading="lazy"><span>' + c + '</span></button>';
          }).join('') + '</div>' +
          '<div class="cw-sizes" role="radiogroup" aria-label="Size">' + cfg.sizes.map(function (s) {
            return '<button type="button" role="radio" class="cw-size" data-size="' + s + '" aria-checked="' + (s === r.size) + '">' + s + '</button>';
          }).join('') + '</div></div>';
      }
      $('[data-rows]').innerHTML = html;
    }

    function renderExtras() {
      var chosen = state.rows.slice(0, state.n).map(function (r) { return r.char; });
      $$('[data-extra]').forEach(function (el) {
        var id = el.dataset.extra, st = state.extras[id];
        el.classList.toggle('is-on', st.on);
        var box = $('input[type="checkbox"]', el);
        if (box) box.checked = st.on;
        var out = $('output', el);
        if (out) out.textContent = st.qty;
        var match = $('[data-match]', el);
        if (match) {
          var hit = (el.dataset.chars || '').split(',').map(function (s) { return s.trim(); }).filter(function (c) { return chosen.indexOf(c) > -1; });
          match.hidden = !hit.length;
          if (hit.length) match.textContent = 'Goes with ' + hit[0];
        }
      });
    }

    function lines() {
      var map = {}, out = [];
      for (var i = 0; i < state.n; i++) {
        var r = state.rows[i], v = cfg.variants[r.char + '|' + r.size];
        if (!v) continue;
        if (!map[v.id]) { map[v.id] = { id: v.id, quantity: 0, price: v.price }; out.push(map[v.id]); }
        map[v.id].quantity++;
      }
      return out;
    }

    function pickedExtras() {
      return cfg.plushies.concat(cfg.addons).filter(function (x) { return state.extras[x.id].on; }).map(function (x) {
        return { id: x.id, title: x.title, price: x.price, quantity: state.extras[x.id].qty };
      });
    }

    function renderTotal() {
      var gross = lines().reduce(function (s, l) { return s + l.price * l.quantity; }, 0);
      var save = off(gross, state.n), extras = pickedExtras(), sum = gross - save;
      var html = '<div class="cw-total__line"><span>Onesies × ' + state.n + '</span><span>' + money(gross) + '</span></div>';
      if (save) html += '<div class="cw-total__line cw-total__line--off"><span>Bundle ' + pct(state.n) + '% off</span><span>−' + money(save) + '</span></div>';
      extras.forEach(function (x) {
        sum += x.price * x.quantity;
        html += '<div class="cw-total__line"><span>' + x.title + (x.quantity > 1 ? ' × ' + x.quantity : '') + '</span><span>' + money(x.price * x.quantity) + '</span></div>';
      });
      html += '<div class="cw-total__sum"><span>Total</span><strong>' + money(sum) + '</strong></div>';
      $('[data-total]').innerHTML = html;
      $$('[data-sum]').forEach(function (el) { el.textContent = money(sum); });
      var r = state.rows[0];
      $('[data-sticky-pick]').textContent = state.n === 1 ? r.char + ' / ' + r.size : state.n + ' onesies';
    }

    function renderAll() { renderTiers(); renderRows(); renderExtras(); renderTotal(); }

    /* Gallery */
    var track = $('[data-track]'), thumbs = $$('[data-thumb]');
    function goTo(i, smooth) {
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', String(k === i));
        if (k === i) { var bar = t.parentNode; bar.scrollLeft = t.offsetLeft - bar.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2; }
      });
    }
    function showChar(c) {
      var i = Array.prototype.findIndex.call(track.children, function (s) { return s.dataset.char === c; });
      if (i > -1) goTo(i, true);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i, true); }); });
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });

    /* Clicks */
    root.addEventListener('click', function (e) {
      var tier = e.target.closest('[data-n]');
      if (tier) { state.n = parseInt(tier.dataset.n, 10); renderAll(); return; }
      var row = e.target.closest('[data-row]');
      if (row) {
        var r = state.rows[parseInt(row.dataset.row, 10)];
        var ch = e.target.closest('[data-char]'), sz = e.target.closest('[data-size]');
        if (ch) { r.char = ch.dataset.char; showChar(r.char); }
        if (sz) r.size = sz.dataset.size;
        if (ch || sz) { renderRows(); renderExtras(); renderTotal(); }
        return;
      }
      var step = e.target.closest('[data-step]');
      if (step) {
        e.preventDefault();
        var st = state.extras[step.closest('[data-extra]').dataset.extra];
        st.qty = Math.max(1, Math.min(10, st.qty + parseInt(step.dataset.step, 10)));
        renderExtras(); renderTotal();
        return;
      }
      if (e.target.closest('[data-order]')) order();
      if (e.target.closest('[data-size-open]')) $('[data-size-dialog]').showModal();
      if (e.target.closest('[data-size-close]')) $('[data-size-dialog]').close();
    });
    root.addEventListener('change', function (e) {
      var el = e.target.closest('[data-extra]');
      if (!el) return;
      state.extras[el.dataset.extra].on = e.target.checked;
      renderExtras(); renderTotal();
    });

    function order() {
      var btns = $$('[data-order]'), err = $('[data-error]');
      err.hidden = true;
      btns.forEach(function (b) { b.disabled = true; });
      var items = lines().map(function (l) { return { id: l.id, quantity: l.quantity }; })
        .concat(pickedExtras().map(function (x) { return { id: x.id, quantity: x.quantity }; }));
      fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        location.href = cfg.cartUrl;
      }).catch(function () {
        btns.forEach(function (b) { b.disabled = false; });
        err.textContent = 'That didn’t go through. Please try again.';
        err.hidden = false;
      });
    }

    /* Delivery window from today's date */
    function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    var now = Date.now(), day = 864e5;
    $('[data-eta]').textContent = fmt(new Date(now + cfg.etaMin * day)) + ' – ' + fmt(new Date(now + cfg.etaMax * day));

    /* Sticky bar shows when the main button is off screen */
    var bar = $('[data-sticky]'), main = $('[data-main-cta]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top > 0 || !e.isIntersecting && e.boundingClientRect.bottom < 0);
      }).observe(main);
    }

    renderAll();
    if (startChar !== cfg.chars[0]) showChar(startChar);
  }

  function boot() { document.querySelectorAll('[data-cw-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
